// CP-238: keyboard access on Detail for the "You Might Also Like" cards and the Sail Dates rows.
//
// Both used to be click-only <div>s: no tab stop, no Enter/Space, no accessible name. They are now
// real <a href> links (Tab reaches them, Enter opens them, middle/ctrl-click still opens a new tab),
// and Space is wired to the same action because the card asks for Enter AND Space on Sail Dates.
// The recommendation cards take their accessible name from their visible text (title, port, date,
// nights, price); an aria-label there would drop the price and trip axe label-content-name-mismatch.
// These helpers are the pure parts: hrefs, the Sail Dates row name, and which clicks the SPA takes over.

function clean(value) {
  return typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "Jan 2, 2027" read from the YYYY-MM-DD text itself so the shopper's timezone never shifts the day.
// '' when there is no real date.
export function keyboardDateLabel(value) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(clean(String(value == null ? '' : value)));
  if (!m) return '';
  const month = Number(m[2]);
  const day = Number(m[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return '';
  return `${MONTHS[month - 1]} ${day}, ${m[1]}`;
}

// "/cruise/13402". null when the id is not usable, so Vue omits href (an <a href=""> would still be a
// focusable link back to this page).
export function recommendationHref(cruise) {
  const id = cruise && cruise.id;
  if (id === undefined || id === null || clean(String(id)) === '') return null;
  return `/cruise/${encodeURIComponent(String(id).trim())}`;
}

// Accessible name for a Sail Dates row link. `shown` is the date text the row displays, so the
// visible text leads the name (WCAG 2.5.3 Label in Name); a raw ISO value is turned into "Jan 2, 2027".
//   current: "Jan 2, 2027, current sailing"   other: "Jan 9, 2027, view this sailing"
export function sailDateRowLabel(shown, isCurrent) {
  const date = keyboardDateLabel(shown) || clean(typeof shown === 'string' ? shown : '') || 'Date not available';
  return isCurrent ? `${date}, current sailing` : `${date}, view this sailing`;
}

// Query string href for a sail date row so the link is a real, copyable URL. null without an id.
export function sailDateHref(cruiseId, date) {
  const id = clean(String(cruiseId == null ? '' : cruiseId));
  if (!id) return null;
  const day = clean(String(date == null ? '' : date));
  // ':' stays literal, the same URL vue-router writes for router.push({ query: { sail_date } }).
  return day ? `/cruise/${encodeURIComponent(id)}?sail_date=${encodeURIComponent(day).replace(/%3A/gi, ':')}` : `/cruise/${encodeURIComponent(id)}`;
}

// True when the SPA should handle the click itself (plain primary click or Enter on the link).
// Modified clicks (new tab / window / download) and non-primary buttons are left to the browser.
export function isPlainActivation(event) {
  if (!event) return true;
  if (event.defaultPrevented) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
  if (event.button !== undefined && event.button !== 0) return false;
  return true;
}
